module.exports = __webpack_public_path__ + "resources/img/img_tibero3_m_jp.740a10e75fefd5e824914bad384c6a7b.png";